var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDarkLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 38,
    viewBox: "0 0 200 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_993_19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.2 31.9V11.8H62.2V31.9H58.2Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2 9.60001C59 9.60001 58 8.60001 58 7.40001C58 6.20001 59 5.20001 60.2 5.20001C61.4 5.20001 62.4 6.20001 62.4 7.40001C62.4 8.60001 61.4 9.60001 60.2 9.60001Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4001 31.9V11.8H71.6001V14C71.6001 14.1 71.7001 14.2 71.8001 14.2H71.9001C72.0001 14.2 72.0001 14.2 72.1001 14.1C73.4001 12.7 76.1001 11.7 78.3001 11.7C78.5001 11.7 78.6001 11.7 78.7001 11.7C78.7001 12.3 78.7001 14.2 78.7001 14.8C78.6001 14.8 78.5001 14.8 78.4001 14.8C76.2001 14.8 73.2001 16.2 71.8001 17.9C71.7001 18 71.7001 18 71.7001 18.7C71.7001 19.1 71.7001 19.6 71.7001 20.3C71.7001 21.6 71.7001 23.4 71.7001 25.1C71.7001 28 71.7001 31 71.7001 31.9H67.4001V31.9Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2 32.3C89.1 32.3 87.5 31.7 86.4 30.6C85.4 29.5 84.8 27.9 84.8 26V15.2C84.8 15.1 84.7 14.9 84.5 14.9H81.7V11.7H84.5C84.6 11.7 84.8 11.6 84.8 11.4V5.60004H89V11.5C89 11.6 89.1 11.8 89.3 11.8H94.5V15H89.3C89.2 15 89 15.1 89 15.3V25.6C89 26.9 89.8 28 91 28.5C91.8 28.8 92.6 29 93.3 29C93.9 29 94.5 28.9 95 28.7C95 29.4 95 30.9 95 32C94.2 32.2 93 32.3 91.2 32.3Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7001 31.9L33.8 11.8H38.2001L43.9001 27.7C43.9001 27.8 44 27.9 44.1 27.9C44.2 27.9 44.3 27.8 44.3 27.7L50 11.8H54.3L46.4001 31.9H41.7001Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.2 32.8C105.7 32.8 103.4 32 101.7 30.6C99.8 29 98.8 26.8 98.8 24.2V11.8H103V24.1C103 25.6 103.6 26.9 104.7 27.8C105.7 28.6 107 29 108.4 29C111.1 29 113.9 27.3 113.9 24.1V11.8H118.1V24.1C118.1 26.2 117.3 28.1 115.9 29.6C114 31.6 111.2 32.8 108.2 32.8Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.9 32.3C187.1 32.3 185.5 32 184.1 31.4C182.7 30.8 181.7 29.8 180.9 28.3C180.1 26.9 179.8 24.9 179.8 22.5C179.8 20.1 180.2 18 181 16.4C181.8 14.8 183 13.5 184.4 12.7C185.8 11.9 187.5 11.4 189.3 11.4C190.5 11.4 191.6 11.5 192.6 11.8C193.5 12.1 194.5 12.5 195.3 13.1H195.4H195.5C195.6 13.1 195.6 13 195.6 12.9V5.60004H199.8V22C199.8 24.2 199.4 26.1 198.7 27.5C198 28.9 197 30 195.7 30.7C194.2 31.8 191.9 32.3 188.9 32.3ZM190.4 14.4C188.3 14.4 186.7 15.1 185.7 16.5C184.7 17.9 184.1 19.9 184.1 22.5C184.1 25 184.6 26.8 185.6 27.8C186.6 28.8 188.1 29.3 190.2 29.3C191.7 29.3 193.1 28.9 194.3 28.2C195.2 27.6 195.8 26.6 195.8 25.5V16.6C195.8 16.5 195.8 16.5 195.7 16.4C194.3 15.1 192.5 14.4 190.4 14.4Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.5 31.5V18.6C149.5 16.9 149.1 15.8 148.4 15.1C147.7 14.4 146.5 14.1 145 14.1C144 14.1 143 14.3 142.1 14.6C141.2 15 140.4 15.5 139.7 16.2L139.6 16.3V16.4C139.7 16.7 139.7 17 139.8 17.3C139.8 17.6 139.8 18 139.8 18.4V31.3H136V18.7C136 17.1 135.7 16 135.2 15.2C134.6 14.4 133.6 14.1 132 14.1C131 14.1 129.9 14.4 129 14.8C128.1 15.3 127.2 15.9 126.5 16.6L126.4 16.7V31.5H122.3V11.5H126.1L126.3 13.9L126.7 13.6C127.7 12.8 128.8 12.2 130 11.7C131.2 11.3 132.5 11 133.8 11C135.2 11 136.3 11.2 137.1 11.7C137.9 12.1 138.5 12.8 138.9 13.6L139.1 13.9L139.4 13.7C140.3 12.9 141.4 12.3 142.6 11.8C143.8 11.3 145.3 11.1 147 11.1C149.3 11.1 151 11.7 152 12.8C153.1 14 153.6 15.8 153.6 18.2V31.5H149.5V31.5Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.2 31.9C166.4 31.9 164.9 31.7 163.5 31.3C162.2 30.9 161 30.2 160 29.4C159.1 28.6 158.3 27.5 157.9 26.2C157.4 24.9 157.2 23.3 157.2 21.5C157.2 19.9 157.4 18.4 157.8 17.2C158.2 15.9 158.8 14.8 159.6 13.9C160.4 13 161.4 12.3 162.7 11.8C163.9 11.3 165.4 11.1 167.1 11.1C168.6 11.1 170 11.3 171.1 11.7C172.2 12.1 173.2 12.7 173.9 13.5C174.7 14.3 175.2 15.2 175.6 16.2C176 17.2 176.2 18.4 176.2 19.6V23.1H161.1V23.4C161.3 25.5 162.1 26.9 163.4 27.7C164.6 28.5 166.6 28.9 169.1 28.9C170.2 28.9 171.2 28.8 172.4 28.6C173.4 28.4 174.2 28.2 174.9 27.9V30.8C174 31.2 173 31.4 171.9 31.6C170.8 31.8 169.5 31.9 168.2 31.9ZM167.2 14C164.9 14 163.3 14.5 162.5 15.5C161.6 16.5 161.2 18.1 161.2 20.2V20.5H172.6V18.8C172.6 17.3 172.2 16.1 171.4 15.3C170.5 14.5 169.1 14 167.2 14Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3 18.9L1.4 7.60002C0.5 6.80002 0 5.60002 0 4.50002C0 0.500023 5.1 -1.39998 8 1.40002L15.2 8.30002L15.6 9.40002C16.8 12.7 15.9 16.4 13.3 18.9Z",
    fill: "url(#paint0_linear_993_19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3 8.20001L15.7 9.30001C16.9 12.7 16 16.4 13.3 18.9L1.4 30.1C0.5 31 0 32.1 0 33.3C0 37.3 5.1 39.2 8 36.4L19.9 25.1C23.6 21.6 23.6 16 19.9 12.5L15.3 8.20001Z",
    fill: "url(#paint1_linear_993_19)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_993_19",
    x1: 0.0000858139,
    y1: 9.43862,
    x2: 16.1576,
    y2: 9.43862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E54197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#522A91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_993_19",
    x1: 0,
    y1: 22.9652,
    x2: 22.6527,
    y2: 22.9652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5223AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23CEDB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_993_19"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 37.8,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkLogo);
export default __webpack_public_path__ + "static/media/dark-logo.f617fd247b04c1064a2b42996916a3d8.svg";
export { ForwardRef as ReactComponent };